import dayjs from 'dayjs';

export type DueDateColor = 'red' | 'yellow' | 'green' | 'none';

export function getDueDateColor(dateStr: string | undefined | null): DueDateColor {
	if (!dateStr) return 'none';
	const today = dayjs().startOf('day');
	const due = dayjs(dateStr).startOf('day');
	const diff = due.diff(today, 'day');
	if (diff <= 0) return 'red';
	if (diff <= 2) return 'yellow';
	return 'green';
}

export const dueDateBorderColor: Record<DueDateColor, string> = {
	red: '#ff4d4f',
	yellow: '#faad14',
	green: '#52c41a',
	none: 'transparent',
};
